export enum EnumRolAtlas {
  Estandar = 1,
  Detalle
}
